import ShortAdd from "./component"

export default ShortAdd